/* eslint-disable max-len */
import React, { Fragment, useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";

import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import useReactPrint from "pages/_components/Print/useReactToPrint";

import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";

import FormattedDate from "pages/_components/FormattedDate";
import { formatNum } from "util/format";
import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";

import { addUtcOffset } from "util/date";
import gaEventTracker, { events } from "util/gaEventTracker";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import Action from "pages/_components/Action";
import { isEmpty } from "lodash";
import { isIOS } from "react-device-detect";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import Avatar from "pages/_components/Avatar";

const NewDepositSuccessTransaction = ({ dispatch, fetching, transaction, activeEnvironment, isDesktop }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "deposits.create.transactionRequest.secondTitle",
        id,
        "deposits",
    );

    const isBackoffice = pathname.includes("backoffice");
    const isFailed = pathname.includes("failed");
    const isLoading = fetching || !transaction?.data;
    const depositData = {
        idTransaction: transaction?.idTransaction || "",

        depositType: `${transaction?.data?.deposit?.depositType}-${transaction?.data?.deposit?.currency}`,
        investCapital: transaction?.data?.deposit?.amountInvested || 0,
        debitAccount: {
            number: transaction?.data?.deposit?.accreditedAccount?.number,
            productAlias: transaction?.data?.deposit?.accreditedAccount?.productAlias,
            productType: transaction?.data?.deposit?.accreditedAccount?.productType,
        },
        termInDays: transaction?.data?.deposit?.coreDeadline,
        expirationAction: transaction?.data?.deposit?.autoRenewal,

        currency: transaction?.data?.deposit?.currency,
        certificate: transaction?.data?.deposit?.depositNumber,
        earnedInterests: transaction?.data?.deposit?.interest || 0,
        chargeAmount: transaction?.data?.deposit?.amountTransfered || 0,
        tna: transaction?.data?.deposit?.rate,
        tea: transaction?.data?.deposit?.effectiveRate,
        expirationDate: transaction?.data?.deposit?.dueDate,
        creationDate: transaction?.data?.deposit?.openDate,
        cuitBiBank: transaction?.data?.deposit?.owner,
        cuitBusinness: transaction?.data?.deposit?.nationalIdentifier,
        profit: transaction?.data?.deposit?.profit,
        stamp: transaction?.data?.deposit?.stamp,
        jurisdiction: transaction?.data?.deposit?.jurisdiction,
        retentions: transaction?.data?.deposit?.retentions,
        iva: transaction?.data?.deposit?.vats,
    };
    const currencyString = i18n.get(`currency.label.${depositData?.currency}`);

    const [showMoreData, setShowMoreData] = useState(false);

    useEffect(() => {
        if (id?.length && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(depositsActions.cleanDepositTicket());
        },
        [],
    );

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.pf_nuevo_constituir_descargar());
        handlePrint();
    };

    return (
        <Fragment>
            <Notification scopeToShow="deposits" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="deposits.summary.title"
                    metaTitle="deposits.summary.title"
                    backLinkTo={state.isCreationFlow ? "/deposits/requestForm" : "/desktop"}
                    className={isIOS ? "ticket-header whitespace-nowrap" : "ticket-header"}>
                    <MobileButtons
                        image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                        {!isFailed && <Action labelKey="global.download" handleClick={() => handleDownload()} />}
                        <Action labelKey="global.share" handleClick={() => handleShareMobile()} />
                    </MobileButtons>
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="deposits.summary.title" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body deposit-success">
                                        <div className="grid-table-data three-cols ticket-section">
                                            <div className="ticket-header-info">
                                                <div className="beneficiary">
                                                    <div className="avatar-name">
                                                        <Avatar
                                                            user={{
                                                                userFullName: `${activeEnvironment?.name}` || "",
                                                                defaultAvatarId: "0",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="user-info">
                                                        <div className="small">{i18n.get("deposits.applicant")}</div>
                                                        <div className="large">{`${activeEnvironment?.name}`}</div>
                                                        <div className="small">{`CUIT: ${activeEnvironment?.activeEnvironmentDocument}`}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <CustomData
                                                keepSpaceIfNotitle
                                                titleTextType="I18N"
                                                titleText="deposits.investCapital"
                                                valueText={`${currencyString} ${formatNum(
                                                    depositData?.investCapital,
                                                    2,
                                                )}`}
                                            />
                                            <div className="custom-data tag tag-echeq-character">
                                                <CustomData
                                                    titleTextType="I18N"
                                                    titleText="deposits.chargeAmount"
                                                    valueText={`${currencyString} ${formatNum(
                                                        depositData?.chargeAmount,
                                                        2,
                                                    )}`}
                                                />
                                                {!isDesktop && <span className="show-print">{": "}</span>}
                                                <span className="custom-text custom-data-value">
                                                    {transaction?.data?.modalities?.map((modality, index) => (
                                                        <>
                                                            {!!index && ", "}
                                                            {i18n.get(`accounts.create.modality.${modality}`)}
                                                        </>
                                                    ))}
                                                    {!!transaction?.data?.modalityReason?.length && (
                                                        <>
                                                            {!!transaction?.data?.modalities?.length && ", "}
                                                            {transaction?.data?.modalityReason}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="view-more-data-button" id="element-to-ignore">
                                            <div className="ticket__divider inside-ticket__body element-to-ignore">
                                                <div className="ticket__notch ticket__notch--left element-to-ignore" />
                                                <div className="ticket__notch ticket__notch--right element-to-ignore" />
                                            </div>
                                            <Button
                                                aria-expanded={showMoreData ? "true" : "false"}
                                                className="more-button no-print"
                                                label={
                                                    showMoreData ? "echecks.seeLess.button" : "echecks.seeMore.button"
                                                }
                                                bsStyle="link"
                                                onClick={() => setShowMoreData((v) => !v)}
                                                image={
                                                    showMoreData
                                                        ? "figma/icon/arrow-up.svg"
                                                        : "figma/icon/arrow-down.svg"
                                                }
                                            />
                                        </div>
                                        <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                            <div className="aditional-data">
                                                <h2>
                                                    {i18n.get("creditBill.aditionalData.label", "Datos adicionales")}
                                                </h2>
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.certificateNumber"
                                                    value={depositData?.certificate}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.type"
                                                    i18nId={`deposit.depositTypes.${depositData.depositType}`}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.debitAccount"
                                                    value={`····${depositData?.debitAccount?.number?.slice(-6)} ${
                                                        depositData?.debitAccount?.productType
                                                    } ${currencyString}`}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.earnedInterests"
                                                    value={`${currencyString} ${formatNum(
                                                        depositData?.earnedInterests,
                                                        2,
                                                    )}`}
                                                />
                                                <TransactionInfo withoutSpace field="deposits.creationDate">
                                                    <FormattedDate
                                                        date={addUtcOffset(depositData?.creationDate)}
                                                        dateFormat="DD/MM/YYYY"
                                                    />
                                                </TransactionInfo>
                                                <TransactionInfo withoutSpace field="deposits.expirationDate">
                                                    <FormattedDate
                                                        date={addUtcOffset(depositData?.expirationDate)}
                                                        dateFormat="DD/MM/YYYY"
                                                    />
                                                </TransactionInfo>
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.termInDays"
                                                    value={depositData?.termInDays}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.tnaDetail"
                                                    value={`${formatNum(depositData?.tna, 2)}%`}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.teaDetail"
                                                    value={`${formatNum(depositData?.tea, 2)}%`}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.expirationAction.label"
                                                    // eslint-disable-next-line max-len
                                                    i18nId={`deposits.expirationAction.${depositData?.expirationAction}`}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.cuitBiBank"
                                                    value={depositData?.cuitBiBank}
                                                />
                                                <TransactionInfo
                                                    withoutSpace
                                                    field="deposits.cuitBusinness"
                                                    value={depositData?.cuitBusinness}
                                                />
                                            </div>
                                            {depositData?.profit && (
                                                <>
                                                    <div className="deposit-retentions ticket-section">
                                                        <h2 className={isIOS && "mb-8"}>
                                                            <CustomData
                                                                titleText="deposits.retentions.perceptions"
                                                                titleTextType="I18N"
                                                            />
                                                        </h2>
                                                        <TransactionInfo
                                                            field="deposits.profits"
                                                            value={`${currencyString} ${formatNum(
                                                                depositData?.profit,
                                                                2,
                                                            )}`}
                                                        />

                                                        {depositData?.stamp && (
                                                            <>
                                                                <TransactionInfo
                                                                    field="deposits.stampCode"
                                                                    value={`${currencyString} ${formatNum(
                                                                        depositData?.stamp,
                                                                        2,
                                                                    )}`}
                                                                />
                                                                <TransactionInfo
                                                                    field="deposits.jurisdiction"
                                                                    value={depositData?.jurisdiction}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            )}

                                            {/* ARBIBIMPLE-8763: Se solicita quitar seccion de IVA */}
                                            {/* <div className="deposit-iva ticket-section">
                                                <h2>{i18n.get("deposits.IVA")}:</h2>
                                                {depositData?.retentions?.map((ret) => (
                                                    <TransactionInfo
                                                        fieldString={ret.name}
                                                        value={currencyString + formatNum(ret.value, 2)}
                                                    />
                                                ))}
                                            </div> */}
                                            <TransactionSign
                                                showMoreData={showMoreData}
                                                customText="pending.approval.cybo"
                                                isDesktop={isDesktop}
                                                creationTime
                                                isSmall
                                                hasVaucher
                                            />
                                        </div>
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print mt-8">
                            <Col xs={12} md={4} mdOffset={2}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn-outline"
                                />
                            </Col>
                            <Col xs={12} md={4} mdOffset={6}>
                                {!isFailed && (
                                    <DesktopButtons>
                                        <CustomButton
                                            className="btn btn-primary"
                                            func={() => handleDownload()}
                                            icon="images/figma/icon/download.svg"
                                            text="global.download"
                                            textType="I18N"
                                        />
                                    </DesktopButtons>
                                )}
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
            {!isDesktop && (
                <Options>
                    <AccountAction isDesktop={isDesktop} labelKey="global.download" handleClick={handlePrint} />
                </Options>
            )}
        </Fragment>
    );
};

NewDepositSuccessTransaction.propTypes = {
    transaction: shape({}).isRequired,
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    fetching: bool,
    activeEnvironment: shape({}).isRequired,
};

NewDepositSuccessTransaction.defaultProps = {
    fetching: false,
};

const mapStateToProps = (state) => ({
    transaction: formSelectors.getTransaction(state),
    fetching: depositsSelectors.getFetching(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(NewDepositSuccessTransaction);
